import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import { StyledCardGridWrapper, CardSlide } from './CardGrid.styles';
import Grid from '../Utility/Grid';
import Adaptive from '../Adaptive';

/**
 *
 * Card grid component that takes in location cards as children
 */
function CardGrid({ children }) {
  //  Logic to determine column configuration based on the number of children
  let columnSplit = { md: '', lg: '', xl: '' };

  if (children.length % 3 === 0) {
    columnSplit = { md: 12 / 3 };
  } else if (children.length % 4 === 0) {
    columnSplit = { md: 12 / 2, lg: 12 / 4 };
  } else if (children.length % 2 === 0) {
    columnSplit = { md: 12 / 2 };
  } else {
    columnSplit = { md: 12 / 3 };
  }

  const staticGrid = React.Children.toArray(children).map(child => (
    <Grid.Col {...columnSplit} key={child.props.id}>
      {child}
    </Grid.Col>
  ));

  const carousel = (
    <Carousel.Container showControls={false} peekNextSlide>
      {React.Children.toArray(children).map(child => (
        <CardSlide key={child.props.id}>{child}</CardSlide>
      ))}
    </Carousel.Container>
  );

  return (
    <StyledCardGridWrapper>
      <Grid.Container>
        <Grid.Row className="row">
          <Adaptive sm={carousel} md={staticGrid} lg={staticGrid} xl={staticGrid} />
        </Grid.Row>
      </Grid.Container>
    </StyledCardGridWrapper>
  );
}

CardGrid.propTypes = {
  /** Card components */
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

CardGrid.defaultProps = {};

export default CardGrid;
